import React, { useEffect } from "react";
import { Amplify } from "aws-amplify";
import { CookieStorage } from "aws-amplify/utils";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { HelmetProvider } from "react-helmet-async";
import { AppRouter } from "components/template";
import {
  AuthProvider,
  ChatProvider,
  CompareProvider,
  SearchProvider,
  ThemeProvider,
} from "contexts";
import "@aws-amplify/ui-react/styles.css";
import outputs from "amplify_outputs.json";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { initClarity } from "services";

Amplify.configure(outputs);

const authConfig = {
  Cognito: {
    userPoolId: outputs.auth.user_pool_id,
    userPoolClientId: outputs.auth.user_pool_client_id,
    cookieStorage: {
      domain: "localhost",
      path: "/",
      expires: 1,
      httpOnly: true,
      sameSite: "strict",
      secure: true,
    },
  },
};

Amplify.configure(
  {
    ...outputs,
    Auth: authConfig,
  },
  { ssr: true }
);

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());

const App: React.FC = () => {
  useEffect(() => {
    initClarity();
  }, []);
  
  return (
    <>
      <HelmetProvider>
        <AuthProvider>
          <ChatProvider>
            <SearchProvider>
              <CompareProvider>
                <ThemeProvider>
                  <AppRouter />
                </ThemeProvider>
              </CompareProvider>
            </SearchProvider>
          </ChatProvider>
        </AuthProvider>
      </HelmetProvider>
    </>
  );
};

export default App;
